import { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationsData, seenAllNotifications } from '../store/Slices/NotificationSlice';
import '../styles/Notification.css';
import { timeAgo } from '../utils/helper';
import { useSocket } from '../utils/SocketContext';
import { bellIcon, noNotificationIcon, notifyIcon } from '../utils/svgs';

const Notification = () => {
    const [showNotify, setShowNotify] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [unSeenCount, setUnseenCount] = useState(0);

    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
    const socket = useSocket();
    const dispatch = useDispatch();

    const notificationRef = useRef(null);

    const { loading, notification, unSeenCount: notificationUnSeenCount,
        seenAllSuccess } = useSelector(state => state.notifications);

    useEffect(() => {
        if (notification) {
            setNotifications(notification);
        }

        if (notificationUnSeenCount) {
            setUnseenCount(notificationUnSeenCount);
        }
    }, [notification, notificationUnSeenCount])

    useEffect(() => {
        if (seenAllSuccess) {
            setUnseenCount(0);
        }
    }, [seenAllSuccess])

    useEffect(() => {
        if (!userDetails?.id || !socket) {
            return;
        }

        const handleCount = (count) => {
            setUnseenCount(count);
        };

        const onConnect = () => {
            socket.off(`message-receiver-${userDetails.id}`, handleCount);
            socket.on(`message-receiver-${userDetails.id}`, handleCount);
        };

        const onConnectError = (err) => {
            console.error('Notification: socket connect_error', err);
        };

        const onReconnect = (attempt) => {
            socket.off(`message-receiver-${userDetails.id}`, handleCount);
            socket.on(`message-receiver-${userDetails.id}`, handleCount);
        };

        socket.on('connect', onConnect);
        socket.on('connect_error', onConnectError);
        socket.on('reconnect', onReconnect);

        if (socket.connected) {
            onConnect();
        } else {
            console.debug('Notification: socket not connected yet, waiting for connect event');
        }

        return () => {
            socket.off('connect', onConnect);
            socket.off('connect_error', onConnectError);
            socket.off('reconnect', onReconnect);
            socket.off(`message-receiver-${userDetails.id}`, handleCount);
        };
    }, [userDetails?.id, socket]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotify(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [notificationRef]);

    return (
        <div className='notification_container' ref={notificationRef}>
            <div
                className='notification_bell_icon'
                onClick={() => {
                    const willOpen = !showNotify;
                    setShowNotify(willOpen);
                    if (willOpen) {
                        dispatch(fetchNotificationsData());
                        dispatch(seenAllNotifications());
                        setUnseenCount(0);
                    }
                }}
            >
                {notifyIcon}
                {
                    unSeenCount > 0 &&
                    <span style={{ position: 'relative' }}>
                        {bellIcon}
                    </span>
                }
            </div>

            {
                showNotify &&
                <div className='notification_content'>
                    <div className='notification_header'>
                        <h6>Notifications</h6>
                        {/* <a>View all notifications</a> */}
                    </div>
                    {
                        loading ? <div className='notification_loading'><Spinner animation="grow" style={{ color: "#4F19E2", width: "20px", height: "20px" }} /></div> :
                            <div className='notification_body'>
                                {
                                    notifications.length === 0 ? <p className='no_notification'>
                                        {noNotificationIcon}
                                        No notifications yet
                                    </p> :
                                        notifications?.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div>{notifyIcon}</div>
                                                    <div dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                                    <span>{timeAgo(item?.created_at)}</span>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                    }
                    <div className='notification_footer'></div>
                </div>
            }
        </div>
    )
}

export default Notification